/**
 * FeedbackFAB — knappen i högra hörnet. Öppnar den gemensamma förslagspanelen
 * (components/forslag/ForslagPanel, BL-169) med ingången "fab". Panelen och formuläret
 * ligger inte längre här: sidfoten, hörnknappen och På gång använder samma panel.
 * Högerklick döljer knappen i 30 minuter.
 */
import React, { useState, useCallback, useEffect } from 'react';
import useFooterAwareFabBottom from '../../hooks/useFooterAwareFabBottom';
import oppnaForslag from '../../components/forslag/oppnaForslag';
import './Feedback.css';

const SNOOZE_KEY = 'kanplan-fab-feedback-snoozed';
const SNOOZE_MS = 30 * 60 * 1000; // 30 min

/** @param {{ basBotten?: number }} props Avstånd till nederkanten i px (högre på /training, ovanför modulspelarens bottenrad). */
export default function FeedbackFAB({ basBotten = 24 }) {
  const [snoozed, setSnoozed] = useState(() => {
    const until = localStorage.getItem(SNOOZE_KEY);
    return until && Date.now() < Number(until);
  });
  const fabBottom = useFooterAwareFabBottom(basBotten);

  useEffect(() => {
    if (!snoozed) return undefined;
    const until = Number(localStorage.getItem(SNOOZE_KEY) || 0);
    const remaining = until - Date.now();
    if (remaining <= 0) { setSnoozed(false); return undefined; }
    const timer = setTimeout(() => setSnoozed(false), remaining);
    return () => clearTimeout(timer);
  }, [snoozed]);

  const handleSnooze = useCallback((e) => {
    e.preventDefault();
    localStorage.setItem(SNOOZE_KEY, String(Date.now() + SNOOZE_MS));
    setSnoozed(true);
  }, []);

  const handleWake = useCallback(() => {
    localStorage.removeItem(SNOOZE_KEY);
    setSnoozed(false);
  }, []);

  return (
    <button
      type="button"
      className={`fb-fab ${snoozed ? 'fb-fab--snoozed' : ''}`}
      style={{ '--fb-fab-bottom': `${fabBottom}px` }}
      onClick={snoozed ? handleWake : () => oppnaForslag({ kalla: 'fab' })}
      onContextMenu={!snoozed ? handleSnooze : undefined}
      title={snoozed ? 'Klicka för att visa igen' : 'Rapportera bugg eller lämna förslag. Högerklicka för att dölja i 30 min'}
      aria-label="Rapportera bugg eller lämna förslag"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M8 2l1.88 1.88M16 2l-1.88 1.88M9 7.13v-1a3 3 0 0 1 6 0v1" />
        <path d="M12 20c-3.3 0-6-2.7-6-6v-3a6 6 0 0 1 12 0v3c0 3.3-2.7 6-6 6z" />
        <path d="M6 13H2M22 13h-4M6 17H3M21 17h-3M6 9H4M20 9h-2" />
      </svg>
    </button>
  );
}
